/*
 * Copyright (c) 2017, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
"use strict";
import Utils from "./Utils";
import axios from 'axios';
import AuthManager from './AuthManager';
import Cookies from 'js-cookie';

class APIClientFactoryOidc {
    constructor() {
        this.environment = Utils.getCurrentEnvironment();
        if (APIClientFactoryOidc._instance) {
            return APIClientFactoryOidc._instance;
        }

        this._APIClientMap = new Map();
        APIClientFactoryOidc._instance = this;
    }

    getAPIClient() {
        const client = axios.create({
            //baseURL: 'https://localhost:9000/apis/bdv/',
            baseURL: '/l/',
            // baseURL: 'http://localhost:8002/l/',
            withCredentials: true,
        });
        
        client.interceptors.request.use(
            function (config) {
                const sessionCookie = Cookies.get('SESSION'); // Retrieve SESSION cookie
                config.headers['Content-Type'] = 'application/json';
                config.headers['Cookie'] = `SESSION=${sessionCookie}`; // Attach session cookie

                return config;
            },
            function (error) {
                return Promise.reject(error);
            }
        );
        
        client.interceptors.response.use(
            function (response) {
                return response;
            },
            function (error) {
                const response = error.response;
                if (response.status === 401) {
                    const userData = AuthManager.getUserFromToken();
                    const existingUser = AuthManager.getUser();
                    if (existingUser) {
                        userData.then((user) => {
                            if (user) {
                                window.location = Settings.app.context + Utils.CONST.LOGOUT_CALLBACK;
                            }
                        }).catch((error) => {
                            console.error('Error occurred while checking token status. Hence redirecting to login', error);
                            window.location = Settings.app.context + Utils.CONST.LOGOUT_CALLBACK;
                        });
                    } else {
                        console.error('Attempted a call to a protected API without a proper access token');
                    }
                }
                return Promise.reject(error);
            }
        );

        return client;
    }
}

APIClientFactoryOidc._instance = null;

export default APIClientFactoryOidc;